import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { AuthenticationHookResult, AuthenticationOidcHookResult } from './use-authentication';

type AuthAdapter = AuthenticationHookResult | AuthenticationOidcHookResult;

export const useAutoLogout = (
    auth: AuthAdapter,
    idleTimeInMinutes: number,
    redirectUri: string,
    debounce = 1000,
    logout: () => Promise<void>,
) => {
    const timeout = 1000 * 60 * idleTimeInMinutes;
    const [isAutoLogoutPolling, setAutoLogoutPolling] = useState(false);

    useEffect(() => {
        const interval = setInterval(async () => {
            if (auth.isAuthenticated && isAutoLogoutPolling) {
                const lastActive = Number(localStorage.getItem('last-active'));
                if (Date.now() - lastActive > timeout) {
                    await logout();
                }
            }
        }, debounce);
        return () => clearInterval(interval);
    }, [isAutoLogoutPolling, debounce, auth, timeout, redirectUri]);

    useIdleTimer({
        timeout,
        debounce,
        onIdle: () => {
            if (auth.isAuthenticated) {
                setAutoLogoutPolling(true);
            }
        },
        onActive: () => {
            if (auth.isAuthenticated) {
                setAutoLogoutPolling(false);
            }
        },
        onAction: () => {
            if (auth.isAuthenticated) {
                localStorage.setItem('last-active', Date.now().toString());
            }
        },
    });
};
